exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media print{@page{margin-top:30px;margin-bottom:0}body{//padding-top:30px;//margin-top:60px;//margin-bottom:-60px;//padding-bottom:-30px}}", ""]);

// exports
